enum Membership {
  REGISTERED_AGENT = 'registered_agent',
  REGISTERED = 'registered',
  CLASSIC = 'classic',
  CLASSIC_AGENT = 'classic_agent',
  SILVER = 'silver',
  GOLD = 'gold',
}

const getMembershipLabel = (membership: Membership, includeSuffix: boolean = true) => {
  const userSuffix = includeSuffix ? ' User' : ''
  const memberSuffix = includeSuffix ? ' Member' : ''

  switch (membership) {
    case Membership.REGISTERED_AGENT:
      return `Registered${userSuffix} - Agent`
    case Membership.REGISTERED:
      return `Registered${userSuffix}`
    case Membership.CLASSIC:
      return `Classic${memberSuffix}`
    case Membership.CLASSIC_AGENT:
      return `Classic${memberSuffix} - Agent`
    case Membership.SILVER:
      return `Silver${memberSuffix}`
    case Membership.GOLD:
      return `Gold${memberSuffix}`
  }
}

function getPositionalValue (tier: Membership | undefined | null) {
  switch (tier) {
    case Membership.GOLD:
      return 3
    case Membership.SILVER:
      return 2
    case Membership.CLASSIC:
    case Membership.CLASSIC_AGENT:
      return 1
    case Membership.REGISTERED_AGENT:
    case Membership.REGISTERED:
    default:
      return 0
  }
}

function getUserMembershipText (
  currentMembershipTier: Membership | undefined | null,
  newMembership: {
    type: Membership,
    title: string,
  },
) {
  if (currentMembershipTier === newMembership.type) {
    switch (currentMembershipTier) {
      case Membership.SILVER:
      case Membership.GOLD:
        return 'Current Membership'
      default:
        return 'Current Tier'
    }
  } else {
    const currentTier = getPositionalValue(currentMembershipTier)
    const newTier = getPositionalValue(newMembership.type)

    if (currentTier > newTier) {
      return 'Manage Subscription'
    } else {
      return 'Upgrade to ' + newMembership.title
    }
  }
}

export {
  Membership,
  getUserMembershipText,
  getMembershipLabel,
}
